import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedAdminCompany: null,
  selectedEmployeeForAudit: null,
  selectedEmployeeForEdit: null,
  listADocuments: [],
  listBDocuments: [],
  listCDocuments: [],
  draftMessage: null,
  isAutofillModalOpen: false,
};

const CompanyAdminSlice = createSlice({
  name: "companyAdmin",
  initialState,
  reducers: {
    setSelectedAdminCompany: (state, actions) => {
      state.selectedAdminCompany = actions.payload;
    },
    setSelectedEmployeeForAudit: (state, actions) => {
      state.selectedEmployeeForAudit = actions.payload;
    },
    setSelectedEmployeeForEdit: (state, actions) => {
      state.selectedEmployeeForEdit = actions.payload;
    },
    setListADocuments: (state, actions) => {
      state.listADocuments = actions.payload;
    },
    setListBDocuments: (state, actions) => {
      state.listBDocuments = actions.payload;
    },
    setListCDocuments: (state, actions) => {
      state.listCDocuments = actions.payload;
    },
    setDraftMessage: (state, actions) => {
      state.draftMessage = actions.payload;
    },
    setIsAutoFillModalOpen: (state, actions) => {
      state.isAutofillModalOpen = actions.payload;
    },
  },
});

export const {
  setSelectedAdminCompany,
  setSelectedEmployeeForAudit,
  setSelectedEmployeeForEdit,
  setListADocuments,
  setListBDocuments,
  setListCDocuments,
  setDraftMessage,
  setIsAutoFillModalOpen,
} = CompanyAdminSlice.actions;

export default CompanyAdminSlice.reducer;
